import { useLocalization } from '../providers/LocaleProvider';
import { toGQLLocale } from '../gql/utils';
export var useGqlLocale = function () {
    var locale = useLocalization().locale;
    return toGQLLocale(locale);
};
